var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('motlet',{attrs:{"options":_vm.motletOptions},scopedSlots:_vm._u([{key:"content",fn:function(ref){
var props = ref.props;
return [_c('line-double-stack',{attrs:{"system":_vm.system,"items":_vm.nodes,"values":_vm.values,"split":_vm.split,"y-axis-names":_vm.yAxisNames,"tooltip-contents":_vm.tooltipContents,"motlet":props.motlet}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }